// extracted by mini-css-extract-plugin
module.exports = {"label":"style-module_label_2CAP3","form":"style-module_form_3QA34"};